// import System from '@/pages/System/Info'
// import Organisation from '@/pages/System/Organisation'
// import User from '@/pages/System/User'
// import UserDetail from '@/pages/System/UserDetail'
// import Role from '@/pages/System/Role'
// import Menu from '@/pages/System/Menu'
// import Dictionary from '@/pages/System/Dictionary'

import i18n from '@/assets/i18n'

export default [
    // 系统管理
    {
        path: '/system/info',
        name: 'info',
        component: () => import('@/pages/System/Info')
    }, {
        path: '/system/organisation',
        name: 'organisation',
        component: () => import('@/pages/System/Organisation')
    }, {
        path: '/system/user',
        name: 'user',
        component: () => import('@pages/User/User'),
        children: [{
            path: 'detail/:id',
            name: 'userDetail',
            component: () => import('@pages/User/UserDetail'),
            props: true,
            meta: {title: i18n.t('system.userProfile')}
        }]
    }, {
        path: '/system/role',
        name: 'role',
        component: () => import('@/pages/System/Role')
    }, {
        path: '/system/menu',
        name: 'menu',
        component: () => import('@/pages/System/Menu')
    }, {
        path: '/system/dictionary',
        name: 'dictionary',
        component: () => import('@/pages/System/Dictionary')
    },
    {
        path: '/system/mobile',
        name: 'mobileConfiguration',
        component: () => import('@/pages/System/MobileConfiguration')
    },
    {
        path: '/system/trainSpecial',
        name: 'trainSpecial',
        component: () => import('@/pages/System/TrainSpecial')
    },


]
